import React from 'react'
import { View, StyleSheet } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { useColors } from '../utils/useColors'

export const InfoCard = ({ children, status = 'info', style }) => {
  const theme = useTheme()
  const colors = useColors()

  return (
    <View style={[styles.container, { borderLeftColor: colors[status], backgroundColor: theme['background-basic-color-2'] }, style]}>
      {children}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
    padding: 8,
    borderLeftWidth: 4,
  },
})